import type { SuggestionView } from '@nightshift/ui-types';

/** Direction is relative to the open ticket, never to the other key printed in the row. */
export function dependencyDirection(
  ticketKey: string,
  otherTicketKey: string,
  direction: SuggestionView['direction'],
) {
  const blocker = direction === 'blocks' ? ticketKey : otherTicketKey;
  const dependent = direction === 'blocks' ? otherTicketKey : ticketKey;
  return {
    blocker,
    dependent,
    relationship: direction === 'overlaps'
      ? `${ticketKey} overlaps with ${otherTicketKey}`
      : `${dependent} depends on ${blocker}`,
    order: direction === 'overlaps'
      ? 'Shared edits. This overlap does not specify a completion order.'
      : `${blocker} must finish before ${dependent} can start.`,
  };
}
